import React, {useEffect, useState} from 'react';
import EyeWrinkle from "../../../../assets/wrinkles/eyewrinkle.png";
import LipWrinkle from "../../../../assets/wrinkles/lipwrinkle.png";
import ForeheadWrinkle from "../../../../assets/wrinkles/wrinkle.png";
import {Button, Divider} from "antd";
import styled from "styled-components";

const WrinklesComponent = ({
                               original_image_url,
                               mask_url,
                               full_detail,
                               created_at,
                               grading_results,
                           }) => {

    const [data, setData] = useState(null);
    const [flipImage, setFlipImage] = useState(false);

    const fetchData = async () => {
        try {
            const response = await fetch(grading_results);
            const result = await response.json();
            setData({data: result});
            console.log('result', result);

            // setSeverity(calculateSeverity());
            // setDepth(calculateDepth());
            // setLength(calculateLength());
        } catch (error) {
            console.error("Error fetching grading results:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [grading_results]);


    const toggleFlip = () => {
        setFlipImage(!flipImage);
    }

    const renderWrinklesAnalysisResult = () => {
        if (!data) return null;

        const results = data.data ?? {};

        return (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" id={full_detail.analysis_id}>
                {mask_url && (
                    <div className="text-center flex justify-between gap-3 rounded-xl overflow-hidden relative">
                        <img src={original_image_url} alt="Image"
                             style={{objectFit: 'cover', width: '100%', height: '100%'}}/>
                        {
                            !flipImage && (
                                <div
                                    className="absolute top-0 left-0 w-full h-full"
                                    style={{
                                        backgroundImage: `url(${mask_url})`,
                                        backgroundSize: '100% 100%',
                                        backgroundPosition: 'center',
                                        opacity: 0.7,
                                        mixBlendMode: 'screen',
                                        filter: 'hue-rotate(210deg) saturate(2)'
                                    }}
                                />
                            )
                        }
                        <Button type="primary" className="absolute left-3 top-3"
                                onClick={toggleFlip}>Flip</Button>
                    </div>
                )}

                <WrinkleWrapper className="flex flex-col gap-3 justify-between items-start bg-white p-3 rounded-xl">
                    <h3 className="font-bold text-center text-black">Wrinkles level</h3>
                    {WrinkleField({
                        icon: EyeWrinkle,
                        title: 'Eye',
                        area: results['crows_feet']['area'],
                        skeleton: results['crows_feet']['skeleton_length'],
                        perimeter: results['crows_feet']['perimeter'],
                        average: results['crows_feet']['avg_width'],
                    })}
                    {WrinkleField({
                        icon: LipWrinkle,
                        title: 'Lips',
                        area: results['lips']['area'],
                        skeleton: results['lips']['skeleton_length'],
                        perimeter: results['lips']['perimeter'],
                        average: results['lips']['avg_width'],
                    })}
                    {WrinkleField({
                        icon: ForeheadWrinkle,
                        title: 'Forehead',
                        area: results['forehead']['area'],
                        skeleton: results['forehead']['skeleton_length'],
                        perimeter: results['forehead']['perimeter'],
                        average: results['forehead']['avg_width'],
                    })}
                </WrinkleWrapper>
            </div>
        );
    };

    const WrinkleField = ({icon, title, area, skeleton, perimeter, average}) => {
        return (
            <div className="bg-[#f1f1f1] flex gap-3 justify-between rounded-xl p-3 w-full">
                <div className="shadow-xl bg-white rounded-xl flex flex-col items-center pb-2 relative"
                     style={{width: '5rem', height: '5rem'}}>
                    <img src={icon} alt="Wrinkle Icon" className="w-full"
                         style={{objectFit: 'cover', width: '3rem', height: '3rem'}}/>
                    <p>{title}</p>
                </div>
                <div className="flex flex-row gap-3 items-center w-full justify-evenly">
                    <div className="flex flex-col gap-2">
                        <p>Area: {area}mm<sup>2</sup></p>
                        <p>Perimeter: {perimeter}mm</p>
                    </div>

                    <Divider type="vertical" style={{height: "100%", borderColor: '#888888'}}/>

                    <div className="flex flex-col gap-2">
                        <p>Skeleton Length: {skeleton}mm</p>
                        <p>Avg. Width: {average}mm</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            {renderWrinklesAnalysisResult()}
        </div>
    );
};


const WrinkleWrapper = styled.div`
    * {
        color: black;
    }
`;

export default WrinklesComponent;